import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Input, Grid, Form, Radio } from 'semantic-ui-react';

import { Column } from 'components/Layout';
import { ComuneResidenza, NazioneResidenza } from '../GeoSuggest';

const MyInput = (props) => {
  const { label, name, onBlur, onChange, readOnly, style, width } = props;
  return (
    <Column width={width}>
      <Form.Field style={style}>
        <label htmlFor={name}>{label}</label>
        <Input {...{ onChange, onBlur, name, readOnly }} defaultValue={props[name]} fluid />
      </Form.Field>
    </Column>
  );
};

MyInput.propTypes = {
  width: PropTypes.number,
  style: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

MyInput.defaultProps = {
  readOnly: false,
};

export class GeoInput extends Component {
  static propTypes = {
    // prop: PropTypes,
    elements: PropTypes.array,
    type: PropTypes.string,
    handleChange: PropTypes.func,
    flat: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  state = {
    comune: '',
    provincia: '',
    regione: '',
    cap: '',
    indirizzo: '',
    nazione: 'Italia',
    nazioneIE: 'IT',
    numeroCivico: '',
    //  indirizzoCompleto: '',
  };

  componentWillMount() {
    this.getIndirizzoInputs(this.props.elements, this.props.type);
  }

  componentWillReceiveProps(nextProps) {
    this.props = nextProps;
    this.getIndirizzoInputs(this.props.elements, this.props.type);
  }

  onBlur = () => {
    this.props.handleChange({ ...this.state });
  };

  // eslint-disable-next-line react/sort-comp
  pad = (num, size, nazione) => {
    const allow = ['ITALIA', 'IT', 'ITAILA', 'itlaia', 'ITALIANA', 'Itaia', 'ITA', 'ITALA', 'Italia'];

    if (allow.indexOf(nazione) === -1) {
      return num;
    }

    return String(num).padStart(5, '0');
  };

  getIndirizzoInputs = (indirizzi, tipo) => {
    const element = !this.props.flat
      ? _.get(
          _.orderBy(
            indirizzi.filter((value) => value.tipo === tipo),
            ['createdAt'],
            ['asc']
          ),
          '[0]'
        )
      : indirizzi[0];
    // const indirizzoCompleto = _.get(element, 'indirizzoCompleto') || '';
    const comune = _.get(element, 'comune') || '';
    const provincia = _.get(element, 'provincia') || '';
    const regione = _.get(element, 'regione') || '';
    const indirizzo = _.get(element, 'indirizzo') || '';
    const nazione = _.get(element, 'nazione') || 'Italia';
    const cap = this.pad(_.get(element, 'cap'), 5, nazione) || '';
    const numeroCivico = _.get(element, 'numeroCivico') || '';
    const nazioneIE = nazione.toLowerCase() === 'italia' ? 'IT' : 'EE';

    this.setState({
      comune,
      provincia,
      regione,
      cap,
      indirizzo,
      nazione,
      numeroCivico,
      nazioneIE,
    });
  };

  handleNazioneIEChange = (e, { value }) => {
    this.setState({ nazioneIE: value, nazione: value === 'IT' ? 'Italia' : ' ' }, this.onBlur);
  };

  render() {
    const { disabled } = this.props;
    return (
      <Grid style={{ marginBottom: 8, marginTop: 0 }}>
        {this.state.nazioneIE === 'IT' && (
          <Column width={6} key="comune-residenza">
            <ComuneResidenza
              initialValue={this.state.comune}
              onChange={(newState) => this.setState(newState, this.onBlur)}
              onBlur={this.onBlur}
              name="comune"
              label="Comune"
              error=""
              required={false}
              disabled={disabled}
            />
          </Column>
        )}

        {this.state.nazioneIE === 'EE' && (
          <MyInput
            {...this.state}
            onBlur={this.onBlur}
            onChange={(e, data) => this.setState({ comune: data.value })}
            width={6}
            name="comune"
            label="Comune"
            readOnly={disabled}
          />
        )}

        <Column width="2">
          <Form.Field>
            <label htmlFor="provincia">Prov.</label>
            <Input
              onChange={(e, data) => this.setState({ provincia: data.value })}
              onBlur={this.onBlur}
              value={this.state.provincia}
              name="provincia"
              fluid
              readOnly={disabled}
            />
          </Form.Field>
        </Column>

        <Column width="5">
          <Form.Field>
            <label htmlFor="regione">Regione</label>
            <Input
              onChange={(e, data) => this.setState({ regione: data.value })}
              onBlur={this.onBlur}
              value={this.state.regione}
              name="regione"
              fluid
              readOnly={disabled}
            />
          </Form.Field>
        </Column>

        <Column width="3">
          <Form.Field>
            <label htmlFor="cap">CAP</label>
            <Input
              onChange={(e, data) => this.setState({ cap: data.value })}
              onBlur={this.onBlur}
              value={this.state.cap}
              name="cap"
              fluid
              readOnly={disabled}
            />
          </Form.Field>
        </Column>

        <MyInput
          {...this.state}
          onBlur={this.onBlur}
          width={8}
          onChange={(e, data) => this.setState({ indirizzo: data.value })}
          name="indirizzo"
          label="Indirizzo"
          readOnly={disabled}
        />
        <MyInput
          {...this.state}
          onBlur={this.onBlur}
          width={2}
          onChange={(e, data) => this.setState({ numeroCivico: data.value })}
          name="numeroCivico"
          label="N°"
          readOnly={disabled}
        />

        {this.state.nazioneIE === 'IT' && (
          <MyInput
            {...this.state}
            onBlur={this.onBlur}
            width={6}
            onChange={(e, data) => this.setState({ nazione: data.value })}
            name="nazione"
            label="Nazione"
            readOnly
          />
        )}

        {this.state.nazioneIE === 'EE' && (
          <Column width={6} key="nazione-residenza">
            <NazioneResidenza
              initialValue={this.state.nazione}
              onChange={(field, value) => this.setState({ nazione: value }, this.onBlur)}
              onBlur={this.onBlur}
              name="nazione"
              error=""
              label="Nazione"
              required={false}
              readOnly={disabled}
            />
          </Column>
        )}

        <Column key="label-nazione-ie" width={10} textAlign="left"></Column>
        <Column key="nazione-ie-i" width={3} textAlign="left">
          <Radio
            name="nazioneIE"
            value={'IT'}
            onChange={this.handleNazioneIEChange}
            label="Italia"
            checked={this.state.nazioneIE === 'IT'}
            disabled={disabled}
          />
        </Column>
        <Column key="nazione-ie-e" width={3} textAlign="right">
          <Radio
            name="nazioneIE"
            value={'EE'}
            onChange={this.handleNazioneIEChange}
            label="Estero"
            checked={this.state.nazioneIE === 'EE'}
            disabled={disabled}
          />
        </Column>
      </Grid>
    );
  }
}

export default GeoInput;



// WEBPACK FOOTER //
// ./app/components/Forms/UI/GeoInput/index.js